<ion-item class="form-element-wrapper" fill="outline" mode="md">
  <ion-input
    [type]="type"
    [label]="label"
    labelPlacement="floating"
    pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{8,}"
    autocapitalize="off"
    mode="ios"
    inputmode="text"
    autocomplete="new-password"
    required="true"
    [formControl]="formCtrl"
    (ionFocus)="showRequirements = true"
    (keyup.enter)="keyupEnter.emit()"
  ></ion-input>
  <fa-icon slot="end" *ngIf="showPasswordIcon" [icon]="showPasswordTextInd ? faEyeSlash : faEye" (click)="onClickPasswordIcon()"></fa-icon>
  <mom-validation-text slot="error" [formCtrl]="formCtrl"></mom-validation-text>
</ion-item>

<ng-container *ngIf="showRequirements">
  <ion-item class="ion-no-margin ion-no-padding" lines="none">
    <ion-text slot="start"><small>weak</small></ion-text>
    <ion-text slot="end"><small>strong</small></ion-text>
  </ion-item>
  <ion-progress-bar type="determinate" buffer="1" [value]="passwordState.passwordStrength" [mode]="'ios'" [color]="passwordState.passwordStrength < 1 ? 'danger' : 'success'">
  </ion-progress-bar>

  <div class="password-step__states">
    <div *ngFor="let state of passwordStates" class="password-step__state">
      <ion-item lines="none" class="ion-no-padding ion-no-margin thin-item">
        <fa-icon slot="start" [icon]="faCircleCheck" [size]="'sm'" [class.checked]="passwordState && passwordState[state.diversityType]"></fa-icon>
        <ion-label class="ion-no-margin">{{ state.requirement }}</ion-label>
      </ion-item>
    </div>
  </div>
</ng-container>
